export default __webpack_public_path__ + "static/media/smoke_1.a0055418.png";